import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { QueryOptions } from './../models/query-options.model';

@Injectable({
  providedIn: 'root'
})
export class WebfeederHttpService {
  protected url: string = environment.API_URLS.WEBFEEDER_REST_API_FACADE
  protected context: string = 'services';

  constructor(
    protected httpClient: HttpClient,
  ) { }

  queryQuote(quote, params?: any): Observable<any> {
    let queryString, queryOptions;
    let url = `${this.url}/${this.context}/quotes/quotesQuery2`;
    queryOptions = {
      query: quote,
      getFractional: true,
      getOptions: true,
      ...params
    }
    if (queryOptions) {
      queryString = QueryOptions.toQueryString(queryOptions)
    }

    queryString = !!queryString ? `?${queryString}` : '';
    return this.httpClient
      .get(`${url}${queryString}`)
      .pipe(
      // tap((data: any) => { data.data = this.convertData(data.data) })
    );
  }

  getSymbolInformation(symbol, params?: any): Observable<any> {
    let queryString, queryOptions;
    let url = `${this.url}/${this.context}/chart/symbols`;
    queryOptions = {
      symbol,
      ...params
    }
    if (queryOptions) {
      queryString = QueryOptions.toQueryString(queryOptions)
    }

    queryString = !!queryString ? `?${queryString}` : '';
    return this.httpClient
      .get(`${url}${queryString}`)
      .pipe(
      // tap((data: any) => { data.data = this.convertData(data.data) })
    );
  }

  symbolChartSearch(params?: any): Observable<any> {
    let queryString, queryOptions;
    let url = `${this.url}/${this.context}/chart/search`;
    queryOptions = {
      ...params
    }
    if (queryOptions) {
      queryString = QueryOptions.toQueryString(queryOptions)
    }

    queryString = !!queryString ? `?${queryString}` : '';
    return this.httpClient
      .get(`${url}${queryString}`)
      .pipe(
      // tap((data: any) => { data.data = this.convertData(data.data) })
    );
  }

  getBars(symbol, params?: any): Observable<any> {
    let queryString, queryOptions;
    let url = `${this.url}/${this.context}/chart/history`;
    queryOptions = {
      symbol,
      ...params
    }
    if (queryOptions) {
      queryString = QueryOptions.toQueryString(queryOptions)
    }

    queryString = !!queryString ? `?${queryString}` : '';
    return this.httpClient
      .get(`${url}${queryString}`)
      .pipe(
      // tap((data: any) => { data.data = this.convertData(data.data) })
    );
  }



  // public create<k>(item: k | any): Observable<HttpResponse<T>> {
  //   return this.httpClient
  //     .post<T>(`${this.url}/${this.version}/${this.endpoint}`, item)
  //     .pipe(map(data => new Object(data) as HttpResponse<T>));
  // }

  // public update<k>(id: string, item: k | any): Observable<HttpResponse<T>> {
  //   return this.httpClient
  //     .put<T>(`${this.url}/${this.version}/${this.endpoint}/${id}`, item)
  //     .pipe(map(data => this.serializer.fromJson(data) as HttpResponse<T>));
  // }

  // read(id: string): Observable<HttpResponse<T>> {
  //   return this.httpClient
  //     .get(`${this.url}/${this.version}/${this.endpoint}/${id}`)
  //     .pipe(map((data: any) => this.serializer.fromJson(data.data) as HttpResponse<T>));
  // }


}



